import { connect } from 'react-redux'
import { loadAlerts, updateAlert, deleteAlert } from 'Modules/user/alerts/actions'
import { googleAnalyticsEvent } from 'Modules/googleAnalytics/actions'
import { loadAlertListings } from 'Modules/user/alerts/searches/actions'
import { selectReComputingTags } from 'Modules/user/alerts/searches/selectors'
import { openModal, closeModal } from 'Modules/modals/actions'
import AlertList from './AlertList'

const mapStateToProps = (state) => ({
  alertListings: state.listingAlert.alertListings,
  isReComputingTags: selectReComputingTags(state),
})
const actions = {
  loadAlerts,
  updateAlert,
  deleteAlert,
  openModal,
  closeModal,
  loadAlertListings,
  googleAnalyticsEvent,
}
export default connect(mapStateToProps, actions)(AlertList)
